module.exports = __webpack_public_path__ + "static/media/back-button-grey.a31dfac0.svg";